module.exports = __webpack_public_path__ + "static/12_core-476dc008b2385f67f5aa0c8f381c3972.jpg";